import Strong from "./Strong";

export { Strong };



// WEBPACK FOOTER //
// ./js/components/Markdown/index.js